import { render, staticRenderFns } from "./infoPublicity.vue?vue&type=template&id=5bb8d69d"
import script from "./infoPublicity.vue?vue&type=script&lang=js"
export * from "./infoPublicity.vue?vue&type=script&lang=js"
import style0 from "./infoPublicity.vue?vue&type=style&index=0&id=5bb8d69d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports